export default __webpack_public_path__ + "static/am-98dc2d8e41cc68841d8804d3b446b670.svg";